import React, { useState, useEffect } from 'react';
import { SelectPicker } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import { calendarClock } from 'whealth-core-web/assets/images';
import './QueueView.scss';
import { useGetLoginUserDataQuery } from 'redux/apiSlice';
import useApiManager from 'networking/ApiManager';
import { timeFormat, dateFormatStringSingleDate } from '../whealth-core-web/components/Helper';
import { useNavigate } from 'react-router-dom';

const QueueView = () => {
  const ApiClient = useApiManager();
  const navigate = useNavigate();
  let userData = useGetLoginUserDataQuery()?.data?.data || {};
  console.log('QueueView userData: ', userData);
  const [modeData] = useState([
    { key: 'in-person', value: 'In-Person' },
    { key: 'virtual', value: 'Virtual' }
  ]);
  const [data, setData] = useState([]);

  // Function to mask phone number - show first 2 and last 3 digits
  const maskPhoneNumber = (phone) => {
    if (!phone) return '';
    const phoneStr = phone.toString();
    if (phoneStr.length < 5) return phoneStr; // If phone is too short, return as is
    
    const firstTwo = phoneStr.substring(0, 2);
    const lastThree = phoneStr.substring(phoneStr.length - 3);
    const maskedMiddle = '*'.repeat(phoneStr.length - 5);
    
    return `${firstTwo}${maskedMiddle}${lastThree}`;
  };

  useEffect(() => {
    if (userData?.id) {
      getQueueAppointments();
    }
  }, [userData]);

  const getQueueAppointments = () => {
    const today = new Date();
    // Convert to IST by adding 5 hours and 30 minutes
    const istDate = new Date(today.getTime());
    const formattedDate = dateFormatStringSingleDate(istDate);
    
    let paramsApp = `?date=${formattedDate}&doctor_id=${userData?.id}&patient_attendance_status=pushed_to_opd`;
    ApiClient.getOpd(paramsApp)
      .then((res) => {
        console.log('getQueueAppointments data: ', res?.data?.data);
        setData(res?.data?.data);
      })
      .catch((err) => {
        console.log('getQueueAppointments error: ', err);
      });
  };

  const renderHeader = () => {
    return (
      <div className="queue-view__header">
        <div className="queue-view__header-content">
          <img src={calendarClock} alt="Calendar Clock" className="queue-view__header-icon" />
          <h1 className="queue-view__header-title">Today's Queue</h1>
        </div>
      </div>
    );
  };

  const goToPatientProfile = (patientId) => {
    navigate(`/patient/${patientId}/dashboard`);
  };

  const showQueue = () => (
    <div className='teamHeader stickyHeader'>
      <div className='headerFilesRow'>
        {renderHeader()}
      </div>

      <div className='teamBody1'>
        <div className='table-responsive'>
          <table className="table table-bordered queue-view__table">
            <thead>
              <tr>
                <th className="queue-view__table-queue">Queue</th>
                <th className="queue-view__table-timestamp">OPD Time</th>
                <th className="queue-view__table-patient-details">Patient Details</th>
                <th className="queue-view__table-mode">Mode</th>
                <th className="queue-view__table-mode">Insurance Category</th>
                <th className="queue-view__table-actions">Actions</th>
                {/* <th className="queue-view__table-consult">Consult Done</th> */}
              </tr>
            </thead>
            <tbody>
              {data ? data.map((row, index) => (
                <tr key={row?.id}>
                  <td>{index + 1}</td>
                  <td>{timeFormat(row?.created_at)}</td>
                  <td>
                    <div className='queue-view__table-patient-name'>{row?.patient_name}</div>
                    <div className="queue-view__table-patient-info">{`${maskPhoneNumber(row?.phone)}${row?.gender ? `, ${row.gender}` : ''}`}</div>
                    {row?.sub_source && (
                      <div className="queue-view__table-patient-info"><strong style={{ color: '#243B86' }}>Sub Source:</strong> {row.sub_source}</div>
                    )}
                  </td>
                  <td className='queue-view__table-mode'>
                    {/* <SelectPicker
                      data={modeData}
                      defaultValue={row.mode}
                      style={{ width: '100%' }}
                      cleanable={false}
                      disabled
                    /> */}
                    {row?.created_type}
                  </td>
                  <td>{row?.user_insurance_category}</td>
                  <td>
                    <div className='action-buttons'>
                      <button onClick={() => goToPatientProfile(row?.patient_id)} className='me-2 queue-view__table-button'>View Profile</button>
                    </div>
                  </td>
                  {/* <td>{row?.consult_done_status ? 'Yes': 'No'}</td> */}
                </tr>
              )) : "No Data Found"}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  return (
    <div className='wrapper'>
      {showQueue()}
    </div>
  );
};

export default QueueView; 